export const typographyClamps = {
  // Headings
  h1: 'clamp(2.5rem, 1.5rem + 5vw, 6rem)', // 40px → 96px
  h2: 'clamp(2rem, 1.2rem + 3vw, 3.75rem)', // 32px → 60px
  h3: 'clamp(1.75rem, 1rem + 2.5vw, 3rem)', // 28px → 48px
  h4: 'clamp(1.5rem, 0.9rem + 2vw, 2.125rem)', // 24px → 34px
  h5: 'clamp(1.25rem, 0.8rem + 1.5vw, 1.5rem)', // 20px → 24px
  h6: 'clamp(1rem, 0.7rem + 1vw, 1.25rem)', // 16px → 20px

  // Body text
  body1: 'clamp(0.9rem, 0.8rem + 0.4vw, 1rem)', // 14.5px → 16px
  body2: 'clamp(0.75rem, 0.7rem + 0.3vw, 0.9rem)', // 12px → 14.5px

  // Subtitles
  subtitle1: 'clamp(1rem, 0.85rem + 0.4vw, 1.125rem)', // 16px → 18px
  subtitle2: 'clamp(0.875rem, 0.8rem + 0.3vw, 1rem)', // 14px → 16px

  // Small text
  caption: 'clamp(0.7rem, 0.65rem + 0.3vw, 0.8rem)', // 11px → 12.8px
  overline: 'clamp(0.7rem, 0.65rem + 0.2vw, 0.75rem)', // 11px → 12px
  button: 'clamp(0.8rem, 0.7rem + 0.3vw, 0.875rem)', // 13px → 14px

  fontSize10: 'clamp(0.625rem, 1.2vw, 0.75rem)', // 10px
  fontSize11: 'clamp(0.688rem, 1.3vw, 0.8125rem)', // 11px
  fontSize12: 'clamp(0.75rem, 1.4vw, 0.875rem)', // 12px
  fontSize13: 'clamp(0.813rem, 1.5vw, 0.9375rem)', // 13px
  fontSize14: 'clamp(0.875rem, 1.6vw, 1rem)', // 14px
  fontSize15: 'clamp(0.938rem, 1.7vw, 1.0625rem)', // 15px
  fontSize16: 'clamp(1rem, 1.8vw, 1.125rem)', // 16px
  fontSize17: 'clamp(1.063rem, 2vw, 1.25rem)', // 17px
  fontSize18: 'clamp(0.875rem, 2vw, 1.5rem)', // 18px
  fontSize20: 'clamp(1rem, 2.2vw, 1.75rem)', // 20px
  fontSize22: 'clamp(1.0625rem, 2.5vw, 1.875rem)', // 22px
  fontSize24: 'clamp(1.125rem, 3vw, 2.125rem)', // 24px
};
